import { Button, styled } from '@mui/material';

export const SolidButton = styled(Button)`
  background-color: ${(props) => props.theme.palette.common.azureBlue};
  color: ${(props) => props.theme.palette.common.white};
  font-weight: 600;
  font-size: 1.167rem;
  line-height: 1.333rem;
  letter-spacing: 0.104rem;
  padding: 1rem 1.334rem;
  width: max-content !important;

  &:hover {
    background-color: ${(props) => props.theme.palette.common.surfaceAction};
  }

  &:disabled {
    user-select: none;
    pointer-events: none;
    background-color: ${(props) => props.theme.palette.common.surfaceDisabled};
    cursor: not-allowed;
    color: ${(props) => props.theme.palette.common.azureBlue};
    border: 0.167rem solid ${(props) => props.theme.palette.common.azureBlue};
  }

  &:focus {
    background-color: ${(props) => props.theme.palette.common.azureBlue};
  }
`;

/**
 * `SolidButton` on a coloured surface -- the CRS banner, which is blue.
 *
 * Built from `SolidButton` rather than styled from scratch so it inherits the
 * standard size, weight and tracking. The banner previously carried its own
 * button with its own padding and font size, and the two sat side by side on
 * the dashboard visibly different sizes.
 */
export const InvertedSolidButton = styled(SolidButton)`
  background-color: ${(props) => props.theme.palette.common.white};
  color: ${(props) => props.theme.palette.common.azureBlue};
  /* Sentence case: these are labels the reader reads, not a shout. */
  text-transform: none;
  letter-spacing: 0;

  &:hover {
    background-color: ${(props) => props.theme.palette.common.veryLightGrey};
  }

  &:focus {
    background-color: ${(props) => props.theme.palette.common.white};
  }
`;

export const StyledHeader = styled('h3')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.33334rem',
  lineHeight: '2rem',
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.common.surfaceDisabled
      : theme.palette.common.outerSpace,
  margin: 0,
  marginBottom: '0.5rem',
}));

export const StyledParagraph = styled('p')(({ theme }) => ({
  fontWeight: 400,
  fontSize: '1rem',
  lineHeight: '1.3334rem',
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.common.surfaceDisabled
      : theme.palette.common.outerSpace,
  margin: 0,
}));
